import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../lib/i18n/LanguageContext';
import { dictionary } from '../lib/i18n/dictionary';
export function Footer() {
  const {
    lang
  } = useLang();
  const t = dictionary.footer;
  const navLinks = [{
    label: t.links.home[lang],
    to: '/'
  }, {
    label: t.links.about[lang],
    to: '/about'
  }, {
    label: t.links.suppliers[lang],
    to: '/suppliers'
  }, {
    label: t.links.faq[lang],
    to: '/faq'
  }, {
    label: t.links.resources[lang],
    to: '/resources'
  }, {
    label: t.links.contact[lang],
    to: '/contact'
  }];
  const formLinks = [{
    label: t.links.supplierApplication[lang],
    to: '/#supplier-form'
  }, {
    label: t.links.buyerIntake[lang],
    to: '/#buyer-form'
  }, {
    label: t.links.compliance[lang],
    to: '/#compliance'
  }, {
    label: t.links.privacy[lang],
    to: '/privacy'
  }, {
    label: t.links.terms[lang],
    to: '/terms'
  }];
  return <footer className="bg-navy-deep border-t border-white/10" data-id="element-99">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14" data-id="element-100">
        <div className="grid md:grid-cols-12 gap-10" data-id="element-101">
          <div className="md:col-span-5" data-id="element-102">
            <Link to="/" className="flex items-center gap-2.5 mb-4" data-id="element-103">
              <span className="relative inline-flex items-center justify-center w-8 h-8 border border-gold/50 rounded-sm" data-id="element-104">
                <span className="absolute inset-1 bg-gold/15" data-id="element-105" />
                <span className="relative font-serif text-gold text-sm" data-id="element-106">A</span>
              </span>
              <span className="text-white text-[15px] font-medium tracking-tight" data-id="element-107">
                America's Energy Bridge by Sr. Navarro LLC
              </span>
            </Link>
            <p className="text-slate-400 text-sm max-w-md leading-relaxed" data-id="element-108">
              {t.tagline[lang]}
            </p>
            <p className="mt-5 text-slate-500 text-[12px] leading-relaxed max-w-md" data-id="element-109">
              {t.disclaimer[lang]}
            </p>
          </div>

          <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8" data-id="element-110">
            <div data-id="element-111">
              <p className="font-mono text-[10.5px] tracking-[0.2em] uppercase text-gold-deep mb-4" data-id="element-112">
                {t.navigate[lang]}
              </p>
              <ul className="space-y-2.5" data-id="element-113">
                {navLinks.map(l => <li key={l.label} data-id="element-114">
                    <Link to={l.to} className="text-slate-300 hover:text-white text-sm transition-colors" data-id="element-115">
                      {l.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
            <div data-id="element-116">
              <p className="font-mono text-[10.5px] tracking-[0.2em] uppercase text-gold-deep mb-4" data-id="element-117">
                Forms
              </p>
              <ul className="space-y-2.5" data-id="element-118">
                {formLinks.map(l => {
                const isAnchor = l.to.startsWith('/#');
                return <li key={l.label} data-id="element-119">
                      {isAnchor ? <a href={l.to} className="text-slate-300 hover:text-white text-sm transition-colors" data-id="element-120">
                          {l.label}
                        </a> : <Link to={l.to} className="text-slate-300 hover:text-white text-sm transition-colors" data-id="element-121">
                          {l.label}
                        </Link>}
                    </li>;
              })}
              </ul>
            </div>
            <div className="col-span-2 sm:col-span-1" data-id="element-122">
              <p className="font-mono text-[10.5px] tracking-[0.2em] uppercase text-gold-deep mb-4" data-id="element-123">
                {t.office[lang]}
              </p>
              <p className="text-slate-300 text-sm leading-relaxed" data-id="element-124">
                Sr. Navarro LLC
                <br data-id="element-125" />
                Houston · Caracas Corridor
              </p>
              <p className="mt-5 font-mono text-[10.5px] tracking-[0.2em] uppercase text-gold-deep mb-2" data-id="element-126">
                {t.languages[lang]}
              </p>
              <p className="text-slate-300 text-sm" data-id="element-127">English · Español</p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-[12px] text-slate-500" data-id="element-128">
          <p data-id="element-129">
            © {new Date().getFullYear()} Sr. Navarro LLC. {t.rights[lang]}
          </p>
          <a href="#admin" className="hover:text-gold transition-colors font-mono tracking-wider" data-id="element-130">
            {t.internal[lang]}
          </a>
        </div>
      </div>
    </footer>;
}